/**
 * @file index.js
 * @author Fernando Ruano
 * @description Initialize Kidney Progress View.
 */

// Commons
import {
  mapStateToProps,
  mapDispatchToProps
} from '@nephro/commons/mapReduxCRUD/index';

// Dependencies
import { connect } from 'react-redux';
// View
import View from './KidneyProgressView';

/**
 * Map state to props
 * @returns { object }
 */
export const mapStateToPropsKidneyProgress = mapStateToProps;
export const mapDispatchToPropsKidneyProgress = mapDispatchToProps;

export default connect(
  mapStateToPropsKidneyProgress,
  mapDispatchToPropsKidneyProgress
)(View);
